import { StreetAddress } from '../streetAddress/streetAddress';

export class Person {
  static defaultCCCode: string = 'US'; // ???

  fullName: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phone: string | undefined;
  fax: string | undefined;
  ccCode: string = Person.defaultCCCode;
  public streetAddress: Partial<StreetAddress> | undefined;

  street1: string | undefined;
  street2: string | undefined;
  city: string | undefined;
  state: string | undefined;
  postalCode: string | undefined;
  country: string | undefined;

  //formattedPhone: string| undefined;
  //phoneNumber: PhoneNumber | undefined;
  //faxNumber: PhoneNumber | undefined;

  constructor(p: Partial<Person>) {
    // if (p.lastName != "Dahlheimer") {
    //     console.log("Person constructor", p);
    // }

    if (p.firstName == null)
      throw new Error(
        `Invalid person in constructor: ${JSON.stringify(p)}\n firstName cannot be null`,
      );
    if (p.lastName == null)
      throw new Error(
        `Invalid person in constructor: ${JSON.stringify(p)}\n lastName cannot be null`,
      );
    if (p.emailAddress == null)
      throw new Error(
        `Invalid person in constructor: ${JSON.stringify(p)}\n email address cannot be null`,
      );

    this.firstName = p.firstName;
    this.lastName = p.lastName;
    this.emailAddress = p.emailAddress;
    this.phone = p.phone;
    this.fax = p.fax;

    // Hack
    this.street1 = p.street1;
    this.street2 = p.street2;
    this.city = p.city;
    this.state = p.state;
    this.postalCode = p.postalCode;
    this.country = p.country;

    this.streetAddress = p.streetAddress;

    if (this.street1 != null) {
      // console.log("Creating street address", this.street1, this.street2, this.city, this.state, this.postalCode, this.country);
      this.streetAddress = new StreetAddress({
        street1: this.street1,
        street2: this.street2,
        city: this.city,
        state: this.state,
        postalCode: this.postalCode,
        country: this.country,
      });
    }

    // if (p.lastName != "Dahlheimer") {
    //     console.log("Street address", this.streetAddress);
    // }

    if (p.ccCode) {
      this.ccCode = p.ccCode;
    }

    this.fullName = this.firstName + ' ' + this.lastName;
  }

  static createEmpty(): Partial<Person> {
    return {
      firstName: '',
      lastName: '',
      fullName: '',
      emailAddress: '',
      phone: '',
      fax: '',
      streetAddress: StreetAddress.createEmpty(),
    };
  }

  static clone(p: Partial<Person>): Partial<Person> {
    let p2 = new Person(JSON.parse(JSON.stringify(p)));
    return p2;
  }
}
